import React, { Component } from 'react'
import { toJS } from 'mobx'
import { Navbar, Nav, NavItem, NavDropdown, MenuItem, Button, OverlayTrigger, Popover, Glyphicon, ListGroupItem, ListGroup } from 'react-bootstrap'
import { Link } from 'react-router'
import { observer, inject } from 'mobx-react'
import NotificationListItem from '../components/NotificationListItem'
import Logger from '../stores/Logger'
import { LinkContainer } from 'react-router-bootstrap'
import './css/Spinner.css'
import '../containers/css/Header.css'
import * as helpers from '../lib/HelperFunctions'
// import { listModes } from '../containers/IdeaList'


let glyphColor = 'white'
export const majorModes = Object.freeze({
    ideas: 1,
    progress: 2,
})

class Header extends Component {

    constructor(props) {
        super(props)
        this.state = {
            selectedKey: 1,
            imgSrc: '/bulb_off.svg',
            notification: false,
            open: false,
            teamPhotoURL: '',
        }
        this.viewTeam = this.viewTeam.bind(this)
        this.notificationTrigger = this.notificationTrigger.bind(this)
        this.handleMouseOver = this.handleMouseOver.bind(this)
        this.findTeamMember = this.findTeamMember.bind(this)
        this.handleMouseOut = this.handleMouseOut.bind(this)
        this.returnActive = this.returnActive.bind(this)
        this.handleToggle = this.handleToggle.bind(this)
    }
    handleMouseOver() {
        this.setState({ imgSrc: '/bulb_on.svg' })
    }
    handleMouseOut() {
        this.setState({ imgSrc: '/bulb_off.svg' })
    }
    componentWillReceiveProps(){
        const { stores } = this.props
        const { store, authStore, routingStore} = stores
        const { theIdea } = store
        const {location} = routingStore
        if(theIdea){
            if(theIdea.hasOwnProperty('teamId')){
                authStore.findTeam(theIdea.teamId).then((team) => {
                    if(location.pathname.startsWith('/idea/') === true){
                        this.setState({teamPhotoURL: team.val().photoURL})
                    } else {
                        this.setState({teamPhotoURL: ''})
                    }
                })
            } else {
                this.setState({teamPhotoURL: ''})
            }
        }
    }
    returnActive(teamKey) {
        const { stores } = this.props
        const { authStore } = stores
        let team = authStore.auth.primaryTeam
        if (team !== undefined) {
            if (team.key === teamKey) {
                return true
            }
            else return false
        }
        else return false
    }
    handleLogout() {
        const { stores } = this.props
        const { authStore } = stores

        this.props.stores.store.logout()
        authStore.signOut()
    }
    onMenuSelect(key) {
        Logger.trackEvent('onMenuSelect', 'key', key)
        // this.setState({ selectedKey: key })
    }
    newIdea(e) {
        const { routingStore } = this.props.stores
        const { push } = routingStore
        Logger.trackEvent('newIdeaStarted')
        push('/idea/new')
    }
    myNotifications() {
        const { stores } = this.props
        const { notificationStore } = stores
        return helpers.toArray(notificationStore.notifications).reverse()
    }
    clearNotifications(e) {
        const { stores } = this.props
        const { notificationStore } = stores
        this.refs.overlay.hide()
        Logger.trackEvent('clearNotifications')
        notificationStore.clearMyNotifications()
    }
    findTeamMember(teamKey, userID) {
        const { stores } = this.props
        const { teamStore } = stores
        return teamStore.findTeam(teamKey, userID)
    }
    notificationTrigger() {
        const { stores } = this.props
        const { notificationStore } = stores
        glyphColor = 'white'
        notificationStore.markMyNotificationsAsDelivered()
    }
    filter(e) {
        const { stores } = this.props
        const { store } = stores
        store.filter = e.target.value
        Logger.trackEvent('filterIdeas', 'filterString', e.target.value)
    }
    viewTeam(team,realteam, inIdeaPage, theIdea) {
        const { stores } = this.props
        const { store, authStore, routingStore } = stores
        const { push } = routingStore
        if(inIdeaPage) {
            if(theIdea.hasOwnProperty('status')) {
                push('/idea-storage/')
                store.infoAlert = `You are now viewing ideas in storage for team: ${realteam.teamName}`
                window.setTimeout(() => {
                    store.infoAlert = undefined
                }, 4000)
            } else {
                push('/ideas/')
                store.infoAlert = `You are now viewing ideas for team: ${realteam.teamName}`
                window.setTimeout(() => {
                    store.infoAlert = undefined
                }, 4000)
            }
        }
        if (authStore.primaryTeam() !== team) {
            let inIdeaPage = false
            return authStore.changeTeam(team, inIdeaPage).then(() => {
                //store.subscribeToAllIdeas()
            })
        }
    }
    handleToggle() {
        this.setState({ open: (!this.state.open) })
    }
    render() {
        let notifslist = []
        notifslist = this.myNotifications()
        let notificationStyling = ''
        let clearButtonStyling = ''
        if (notifslist.length > 3) {
            notificationStyling = 'notificationsPopoverLong'
            clearButtonStyling = 'clearNotificationsButton'
        }
        else if (notifslist.length < 1) {
            notificationStyling = 'notificationsPopoverNone'
            clearButtonStyling = 'clearNotificationsButtonNone'
        }
        else {
            notificationStyling = 'notificationsPopoverShort'
            clearButtonStyling = 'clearNotificationsButton'
        }
        const popoverBottom = (
            <Popover className={notificationStyling} id='popover-trigger-focus' title='Notifications'>
                <ListGroup className='notificationsListGroup' fill>
                    {notifslist.map((notif) =>
                        <ListGroupItem key={notif.key}>
                            <Link onClick={() => this.refs.overlay.hide()} to={{ pathname: notif.click_action }}>
                                <NotificationListItem item={notif} />
                            </Link>
                        </ListGroupItem>,
                    )}
                </ListGroup>
                <div className={clearButtonStyling}>
                    <Button block onClick={(e) => this.clearNotifications(e)}>Clear</Button>
                </div>
            </Popover>
        )
        const { stores } = this.props
        const { store, authStore, notificationStore, routingStore, prefStore } = stores
        const { push } = routingStore
        const {location} = routingStore
        const { theIdea } = store
        let inIdeaPage = location.pathname.startsWith('/idea/') ? true : false
        let team = authStore.auth.primaryTeam
        let teamPhotoUrl = '/Logo.png'
        if(theIdea && theIdea.hasOwnProperty('teamId')){
            authStore.findTeam(theIdea.teamId).then((team) => {
                teamPhotoUrl = team.val().photoURL
            })
        } else if (location.pathname.startsWith('/idea/') && theIdea && theIdea.hasOwnProperty('teamId') === false){
            teamPhotoUrl = '/Logo.png'
        } else {
            teamPhotoUrl = team.photoURL ? team.photoURL : '/Logo.png'
        }
        if(this.state.teamPhotoURL !== ''){
            teamPhotoUrl = this.state.teamPhotoURL
        } else {
            teamPhotoUrl = team.photoURL ? team.photoURL : '/Logo.png'
        }
        var canAddIdea = true
        if(inIdeaPage){
            if(theIdea){
                if(!theIdea.hasOwnProperty('lastUpdated')){
                    canAddIdea = false
                } else {
                    canAddIdea = true
                }
            } else {
                canAddIdea = true
            }
        } else {
            canAddIdea = true
        }
        const authUser = authStore.auth.authUser
        let dispName = 'Welcome'
        let photoURL = null
        let userProfile = authStore.auth.userProfile && Object.keys(authStore.auth.userProfile).length > 0 ? authStore.auth.userProfile : null
        if (userProfile) {
            dispName = userProfile.displayName ? userProfile.displayName : authUser.email.split('@')[0]
            photoURL = userProfile.photoURL ? userProfile.photoURL : authUser.photoURL
        }

        const primaryTeam = toJS(authStore.primaryTeam())
        let isAllowed = false

        if (notificationStore.newNotifications) {
            glyphColor = '#ED1558'
        } else {
            glyphColor = 'white'
        }
        if (primaryTeam.key) {
            isAllowed = this.findTeamMember(primaryTeam.key, authUser.uid)
        }
        let showTeamDropdown = true
        let assignedTeams = authStore.auth.assignedTeams
        let rightContainerStyling = ''
        let innerContainerStyling = ''
        let headerBoxStyling = ''
        let headerLogoStyling = ''
        let newIdeaButtonContainer = ''
        if (prefStore.openSidebar === true) {
            rightContainerStyling = 'headerRightContainerOpen'
            innerContainerStyling = 'headerOpenContainer'
            headerBoxStyling = 'headerBoxOpen'
            headerLogoStyling = 'headerLogoOpen'
            newIdeaButtonContainer = 'headerNewIdeaContainerOpen'
        } else {
            rightContainerStyling = 'headerRightContainerCollapse'
            innerContainerStyling = 'headerCollapseContainer'
            headerBoxStyling = 'headerBoxCollapse'
            headerLogoStyling = 'headerLogoCollapse'
            newIdeaButtonContainer = 'headerNewIdeaContainerCollapse'
        }
        return (
            <div className='Header'>
                <div className='headerLeftContainer'></div>
                <Navbar className={rightContainerStyling} inverse>
                    <Navbar.Brand className={headerLogoStyling}>
                        <a style={{ cursor: 'pointer', display: 'inline-block' }} onClick={(e) => push('/ideas/')}><div style={{ backgroundImage: 'url(' + teamPhotoUrl + ')', backgroundPosition: 'left center', backgroundSize: 'contain', backgroundRepeat: 'no-repeat', objecFit: 'scale-down' }} alt='PRE.DO' className='HeaderTeamLogo' /></a>
                    </Navbar.Brand>
                    <Navbar.Toggle style={{ marginRight: 0 + 'px' }} />
                    <Navbar.Header>
                        <div>
                            <a style={{ display: 'inline-block' }}><div className={headerBoxStyling} /></a>
                        </div>
                    </Navbar.Header>
                    <Navbar.Collapse className={innerContainerStyling}>
                        {store.isLoggedIn &&
                            <Navbar.Text className={newIdeaButtonContainer}>
                                <Button onMouseOver={this.handleMouseOver} onMouseOut={this.handleMouseOut} style={{ textDecoration: 'none', outline: 'none' }} className='headerNewIdea' bsStyle='link' disabled={!canAddIdea} onClick={(e) => this.newIdea(e)}>
                                    <img className='headerNewIdeaImage' src={this.state.imgSrc} alt='New Idea' /> <strong className='ideaText'>New Idea</strong>
                                </Button>
                            </Navbar.Text>
                        }
                        {/*store.isLoggedIn &&
                        <InputGroup>
                            <InputGroup.Addon className='searchWrapper'><Glyphicon glyph='search'/></InputGroup.Addon>
                            <FormControl type='text' placeholder='Filter' value={store.filter} onChange={this.filter.bind(this)}/>
                        </InputGroup>
                    */}
                        <Nav className='profilePhoto' pullRight activeKey={this.state.selectedKey} onSelect={this.onMenuSelect.bind(this)}>
                            {authUser &&
                                <OverlayTrigger style={{ display: 'inline-block' }} container={this} trigger='click' ref='overlay' rootClose onClick={() => this.notificationTrigger()} placement='bottom' overlay={popoverBottom}>
                                    <button className='notificationButton'><Glyphicon glyph='inbox' style={{ top: 4 + 'px', color: glyphColor }} /></button>
                                </OverlayTrigger>
                            }
                            {(authUser && photoURL) &&
                                (
                                    <LinkContainer active={false} style={{ display: 'inline-block'}}  className='headerProfileImage' to='/profile'>
                                        <NavItem eventKey={6}>
                                            <img onError={(e)=>{helpers.onImageError(e, dispName)}} src={photoURL} className='headerProfilePicture' alt='HeaderProfileImage' />
                                        </NavItem>
                                    </LinkContainer>
                                )
                            }
                            {authUser &&
                                (
                                    <NavDropdown open={this.state.open} onToggle={this.handleToggle} pullRight className='headerProfileDropdown' eventKey={7} title={dispName} id='basic-nav-dropdown'>
                                        <LinkContainer to='/profile'>
                                            <MenuItem eventKey={7.1}>User Profile</MenuItem>
                                        </LinkContainer>
                                        {isAllowed &&
                                            <LinkContainer to='/team'>
                                                <MenuItem eventKey={7.2}>Team Profile</MenuItem>
                                            </LinkContainer>
                                        }
                                        {/* <LinkContainer to='/plans'>
                                        <MenuItem eventKey={7.2}>Plans</MenuItem>
                                    </LinkContainer> */}
                                    <MenuItem divider />
                                        {(team && showTeamDropdown && assignedTeams.length > 1) &&
                                            <MenuItem disabled>Select team:</MenuItem>
                                        }
                                        {(team && showTeamDropdown && assignedTeams.length > 1) &&
                                            <MenuItem divider style={{backgroundColor: 'white', margin: '2px'}} />
                                        }
                                        {(team && showTeamDropdown && assignedTeams.length > 1) &&
                                            assignedTeams.map((team,index) =>
                                                <MenuItem active={inIdeaPage === false && this.state.open && this.returnActive(team.teamKey)} onClick={() => this.viewTeam(team.teamKey,team , inIdeaPage, theIdea)} key={index}>{team.teamName}</MenuItem>,
                                            )
                                        }
                                        {(team && showTeamDropdown && assignedTeams.length > 1) &&
                                            <MenuItem divider />
                                        }
                                <MenuItem eventKey={7.99} onClick={(e) => this.handleLogout(e)}>Log out</MenuItem>
                                </NavDropdown>
                            )
                        }
                    </Nav>
                </Navbar.Collapse>
                </Navbar>
            </div>
        )
    }
}

export default inject("stores")(observer(Header))



// WEBPACK FOOTER //
// ./src/containers/Header.js